import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function BasicInfo(props) {
  return <EyefinitySectionFields {...props} sectionName="basic_info" title="Basic Info" />
}
